var navbar_show = true;
var toggleSubmenu = function(el){
  if (el.style.maxHeight){
    el.style.maxHeight = null;
  } else {
    el.style.maxHeight = el.scrollHeight + "px";
  }
}

$(function(){
  //** HANDLE SUBMENU LISTENERS **//
  // toggle animation
  var coll = document.getElementsByClassName("collapsible");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      localStorage.setItem("open_dropdown", this.id);
      var content = this.nextElementSibling;
      toggleSubmenu(content);
    });
  }
  // reset open if not submenu
  var std = document.getElementsByClassName("standard-link");
  for (var i = 0; i < std.length; i++) {
    std[i].addEventListener("click", function() {
      localStorage.removeItem('open_dropdown');
    });
  }
  // open selected from submenu
  var submenus = document.getElementsByClassName("nav-second-level");
  for (var i = 0; i < submenus.length; i++) {
    submenus[i].addEventListener("click", function() {
      localStorage.setItem("open_dropdown", this.parentElement.children[0].id);
    });
  }

  //** OPEN SELECTED *//
  var active = document.getElementsByClassName('menu noselect active')[0];
  localStorage.setItem("open_dropdown", active.children[0].id);
  var to_open_menu = document.getElementById(active.children[0].id);
  if (to_open_menu) {
    var submenu = to_open_menu.nextElementSibling;
    toggleSubmenu(submenu);
  }

  //** HANDLE NAVBAR **//
  var toggle = document.getElementById("hide-navbar");
  var mobile_toggle = document.getElementById("show-mobile-navbar");
  var navbar = document.getElementsByClassName("collapsible-nav")[0];
  [toggle, mobile_toggle].forEach(function(el){
    el.addEventListener("click", function() {
      // TODO ANIMATION
      navbar.classList.toggle('hidden');
      navbar_show = !navbar_show;
    });
  });
  $(document).ready(function(){
    if (window.innerWidth <= 1024){
      navbar.classList.add('hidden');
    }
  });
  $(window).resize(function() {
    if (window.innerWidth <= 1024){
      navbar.classList.add('hidden');
    }
    else if(navbar_show) {
      navbar.classList.remove('hidden');
    }
  });

  //** HANDLE TABS **//
  $('a[data-toggle="tab"').on('click', function(e){
    var tab_id = $(e.target).data("target");
    $(".tab-pane").removeClass('active');
    $("#"+tab_id).addClass('active');
  })
});